import { LINK_RETRY_LABEL, LINK_STRIP_LABEL, useLinkStrip } from '@krp/client-runtime'
import { LinkStrip } from '@krp/ui-kit'

/**
 * Строка связи с сервером внутри продажи и окон поверх неё (RP-SALE-FAST, шаг 5, К-107, К-110): «Нет связи 12 с · попытка 3 · обновлено
 * 52 с назад» и «Повторить сейчас». В норме не рисуется. Слова и расчёт — в модели здоровья `client-runtime`; общее окно «Восстанавливаем
 * соединение» на это время скрыто, потому что продажа объявила, что показывает связь сама (`useScreenOwnsLink` в `SaleScreen`).
 * `watchAge` — экран ждёт опроса (ход оплаты читается раз в секунду): тогда виден и возраст данных при живой связи.
 */
export function SaleLinkStrip({ watchAge = false, className }: { watchAge?: boolean; className?: string }) {
  const strip = useLinkStrip(watchAge)
  if (strip === null) return null
  return (
    <LinkStrip
      kind={strip.kind}
      text={strip.text}
      label={LINK_STRIP_LABEL}
      onRetry={strip.retry}
      retryLabel={LINK_RETRY_LABEL}
      {...(className !== undefined ? { className } : {})}
    />
  )
}
